/**
 * Тоог зөөлөн «гүйлгэнэ» — dark glass дизайны count-up, график зурах.
 *
 * Анх 0-ээс, дараа нь ӨМНӨХ утгаас шинэ утга руу (`easeOutCubic`).
 * Жишээ: касс дээр гутал нэмэхэд нийт дүн 189,000 → 334,000 гүйнэ.
 *
 * ⚠️ Зөвхөн ХАРУУЛАХ утга. Мөнгөн тооцоонд хэзээ ч бүү хэрэглэ —
 *    завсрын утга нь бутархай (CLAUDE.md дүрэм 3).
 * ⚠️ `prefers-reduced-motion` үед шууд эцсийн утга — гүйлгэхгүй.
 */

import { useEffect, useRef, useState } from 'react';

const easeOutCubic = (t: number) => 1 - (1 - t) ** 3;

function reducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function useTween(target: number, duration = 1400): number {
  const [value, setValue] = useState(() => (reducedMotion() ? target : 0));
  /** Одоо харагдаж буй утга — шинэ зорилт ирэхэд эндээс үргэлжилнэ. */
  const shown = useRef(value);

  useEffect(() => {
    const from = shown.current;
    if (from === target) return;
    if (reducedMotion() || !Number.isFinite(target)) {
      shown.current = target;
      setValue(target);
      return;
    }

    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      // rAF-ын цаг нь фрэймийн ЭХЛЭЛ — `start`-аас өмнө байж болно, сөрөг t гарна
      const t = Math.min(1, Math.max(0, (now - start) / duration));
      const v = t === 1 ? target : from + (target - from) * easeOutCubic(t);
      shown.current = v;
      setValue(v);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return value;
}
